/* eslint-disable no-new */
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueCookies from 'vue-cookies';
// import WxConfig from '@/assets/js/WxConfig';
// import wx from 'weixin-js-sdk';
import { Empty, Icon, Field, RadioGroup, Radio, DropdownMenu, DropdownItem, List, Popup, Picker, DatePicker, Checkbox, Area, Cell, Switch, PasswordInput, NumberKeyboard, Rate, Loading, Image as VanImage, Dialog, Button, Progress } from 'vant';
import 'vant/lib/index.css';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
// import { Document } from '@element-plus/icons-vue'; // 引入 Edit 图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
// import copy from 'v-copy';
// 引入 Vconsole
// import VConsole from 'vconsole';
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
//  在dev环境使用
// if (process.env.NODE_ENV === 'development') {
// new VConsole();
// };
const app = createApp(App);
// app.config.globalProperties.$wxConfig = WxConfig;
// app.config.globalProperties.wx = wx;
app.use(store).use(router).use(VueCookies);
app.use(Field).use(RadioGroup).use(Radio).use(DropdownMenu).use(DropdownItem).use(List).use(Popup).use(Picker).use(DatePicker).use(Checkbox).use(Area).use(Cell).use(Switch).use(PasswordInput).use(NumberKeyboard).use(Rate).use(Loading).use(VanImage).use(Dialog).use(Button).use(Progress).use(Icon).use(Empty);
// app.use(ElementPlus);
app.use(ElementPlus, { locale: zhCn });
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
// app.component(Document.name, Document); // 全局注册 Edit 图标
// app.use(copy);
app.mount('#app');
